import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import "../layouts/css/style.css";
import React, { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';

import img1 from "../layouts/img/bathroom-background-zoom-calls.png";
import icon1 from "../layouts/img/icon1.png"
import idea1 from "../layouts/img/idea1.png"
import idea2 from "../layouts/img/idea2.png"
import idea3 from "../layouts/img/idea3.png"
import idea4 from "../layouts/img/idea4.png"
import long from "../layouts/img/long.png"
import lastimg from "../layouts/img/lastimg.png"
import unique from "../layouts/img/unique.png"
import ideas1 from "../layouts/img/ideas1.png"
import ideas2 from "../layouts/img/ideas2.png"
import ideas3 from "../layouts/img/ideas3.png"
import ideas4 from "../layouts/img/ideas4.png"

import coffee from "../layouts/img/coffe cup.png"
import human from "../layouts/img/Human.png"
import gps from "../layouts/img/GPS.png"
import house from "../layouts/img/house.png"
import inst from "../layouts/img/inst.png"
import phone from "../layouts/img/phone.png"
import fb from "../layouts/img/facebook.png"
import mail from "../layouts/img/gmail.png"
import setka from "../layouts/img/setka.png"

import { Link } from "react-router-dom";

export default function IndexPage() {
  const phoneNumber = '3279729935';

  const handleCopyPhoneNumber = (event) => {
    event.preventDefault(); // Prevent default behavior of the anchor tag
    navigator.clipboard.writeText(phoneNumber)
      .then(() => {
        console.log('Phone number copied to clipboard:', phoneNumber);
        // Optionally, you can set a state to show a success message or perform other actions
      })
      .catch((error) => {
        console.error('Failed to copy phone number:', error);
        // Handle any errors or provide feedback to the user
      });
  };

  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const scrollToId = urlParams.get("scrollTo");

    // Check if on index page and scrollTo parameter is present
    if (location.pathname === "/" && scrollToId) {
      const targetElement = document.getElementById(scrollToId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  // Scroll-to-top button functionality
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = useCallback(() => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth scrolling animation
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [toggleVisibility]);

  return (
    <>
      <section id="first-section" className="width-class">
        <img id="img1" className="overflow" src={img1} alt="photo of bathroom" />
        <div id="bagni-div">
          <h1 id="first-h1">Ristrutturazione Bagni Torino</h1>
          <p id="intro-text">
            Con anni di esperienza nel settore, siamo i leader indiscussi nella ristrutturazione
            bagni nella regione di Torino. Offriamo soluzioni innovative e personalizzate per
            ogni esigenza, garantendo risultati rapidi e di alta qualità.
          </p>
          <Link to="/Bagni"><button id="first-button">Scopri di più</button></Link>
        </div>
      </section>
      <section id="second-section" className="overflow">
        <section id="what-we-do-section" className="width">
          <h2 id="what-we-do-h2">
            Ci specializziamo in splendide ristrutturazioni di bagni in provincia di Torino
          </h2>
        </section>
      </section>
      <section id="third-section" className="overflow">
        <section id="ideas-section" className="width">
          <div id="ideas-div1">
            <h3 id="ideas-h">
              Idee per la Ristrutturazione
            </h3>
            <p id="ideas-text">
              Scopri le ultime tendenze e idee per la ristrutturazione del tuo bagno.
              Siamo qui per aiutarti a creare uno spazio moderno e funzionale,
              perfettamente adatto alle tue esigenze e al tuo stile.
            </p>
            <Link to="/Bagni"><button id="second-button">Scopri di più</button></Link>
          </div>
          <img src={ideas1} alt="photo of bathroom" id="idea1" className="ideas-photo" />
          <img src={ideas2} alt="photo of bathroom" id="idea2" className="ideas-photo" />
          <img src={ideas3} alt="photo of bathroom" id="idea3" className="ideas-photo" />
          <img src={ideas4} alt="photo of bathroom" id="idea4" className="ideas-photo" />
          <div id="ideas-div2">
            <p id="ideas-ps">
              La nostra squadra di esperti è dedicata a trasformare il tuo
              bagno in uno spazio elegante e funzionale. Utilizziamo materiali
              di alta qualità e le tecniche più avanzate per garantire un
              risultato che superi le tue aspettative.
            </p>
          </div>
        </section>
      </section>
      <section id="fourth-section" className="overflow">
        <div id="blue-line"></div>
        <div className="width">
          <h2 id="inspiration-h2" >
            Siamo spinti a ispirare i nostri clienti
          </h2>
          <p id="inspiration-p">
            Ci impegniamo a ispirare i nostri clienti con soluzioni
            creative e personalizzate, trasformando ogni bagno in
            uno spazio unico e funzionale.
          </p>

          <div id="inspiration-blocks" className="width">
            <div id="inspiration-block-1" className="inspiration-block">
              <img src={idea1} alt="photo of bathroom" />
              <h3>
                Concetti
              </h3>
              <p>
                Ogni progetto inizia con un'idea unica, trasformata in
                concetti innovativi. Il nostro obiettivo è catturare la
                tua visione e renderla realtà.
              </p>
              <Link to="/Bagni">Di più</Link>
            </div>
            <div id="inspiration-block-2" className="inspiration-block">
              <img src={idea2} alt="photo of bathroom" />
              <h3>
                Prototipazione
              </h3>
              <p>
                Realizziamo prototipi dettagliati per garantire che ogni
                elemento del tuo bagno sia perfetto. La precisione è la
                chiave del nostro successo.
              </p> <link rel="stylesheet" href="" />
              <Link to="/Bagni">Di più</Link>
            </div>
            <div id="inspiration-block-3" className="inspiration-block">
              <img src={idea3} alt="photo of bathroom" />
              <h4>
                Interno
              </h4>
              <p>
                Creiamo interni eleganti e funzionali, combinando estetica
                e praticità. Ogni dettaglio è curato per offrire il
                massimo comfort.
              </p>
              <Link to="/Bagni">Di più</Link>
            </div>
          </div>
        </div>
      </section>
      <section id="fifth-section" className="overflow">
        <div id="unique-div">
          <h3>Creiamo progetti di interni unici</h3>
          <p>
            Creiamo progetti di interni unici che valorizzano il tuo spazio
            con stile e funzionalità. Contattaci per trasformare il tuo bagno
            in un ambiente moderno e accogliente.
          </p>
          <Link to="/Bagni"><button>Scopri di più</button></Link>
        </div>
        <img id="unique-img" src={unique} alt="photo of bathroom" />
        <div id="unique-blue"></div>
      </section>
      <section id="sixth-section" className="overflow">
        <section id="design-section">
          <h2>
            Interior Designers
          </h2>
          <img id="design-img" src={long} alt="photo of bathroom" />
          <div id="grid-columns">
            <div className="grid-column">
              <div className="design-grid-img">
                <img src={gps} alt="photo of bathroom" />
              </div>
              <h3>
                2.324
              </h3>
              <h4>
                PROGETTI COMPLETATI
              </h4>
            </div>
            <div className="grid-column">
              <div className="design-grid-img">
                <img src={human} alt="photo of bathroom" />
              </div>
              <h3>
                7.158
              </h3>
              <h4>
                CLIENTI SODDISFATTI
              </h4>
            </div>
            <div className="grid-column">
              <div className="design-grid-img">
                <img src={coffee} alt="photo of bathroom" />
              </div>
              <h3>
                729
              </h3>
              <h4>
                TAZZE DI CAFFÈ
              </h4>
            </div>
            <div className="grid-column">
              <div className="design-grid-img">
                <img src={house} alt="photo of bathroom" />
              </div>
              <h3>
                3.129
              </h3>
              <h4>
                ORE DI LAVORO
              </h4>
            </div>
          </div>
        </section>
      </section>
      <section id="last-section">
        <div id="contact-us-div">
          <h2>Contattaci</h2>
          <div className="contacts">
            <div>
              <img src={phone} alt="photo of bathroom" />
            </div>
            <a href="#" onClick={handleCopyPhoneNumber}>Numero di tel: 3279729935</a>
          </div>
          <div className="contacts">
            <div>
              <img src={mail} alt="photo of bathroom" style={{ height: 'auto', width: '48px' }} />
            </div>
            <a href="https://mail.google.com/mail/u/0/?view=cm&fs=1&to=Edilctorino@gmail.com" target="_blank" rel="noreferrer">Mail: Edilctorino@gmail.com</a>
          </div>
          <div className="contacts">
            <div>
              <img src={fb} alt="photo of bathroom" />
            </div>
            <a href="https://www.facebook.com/profile.php?id=61566510724792" target="_blank" rel="noreferrer">Facebook: Nica Bagni Torino</a>
          </div>
          <div className="contacts">
            <div>
              <img src={inst} alt="" />
            </div>
            <a href="https://www.instagram.com/nica.bagni.torino/" target="_blank" rel="noreferrer"> Instagram: @nica.bagni.torino</a>
          </div>
          <div className="contacts">
            <div>
              <img src={gps} alt="photo of bathroom" />
            </div>
            <a href="https://maps.app.goo.gl/MwpSwXV1Gz6moe4t7" target="_blank" rel="noreferrer">Indirizzo: Via Cavagnolo12 int 34</a>
          </div>
        </div>
        <img id="last-back-img" src={lastimg} alt="photo of bathroom" />
        <img id="setka" src={setka} alt="photo of bathroom" />
        <div id="service-div">
          <h2>Le prestazioni che noi offriamo con il nostro servizio:</h2>
          <div id="service-grid">
            <div>
              <ul>
                <li>
                  <Link to="/Bagni">Ristrutturazione bagno Torino</Link>
                </li>
                <li>
                  <Link to="/Bagni">Ristrutturazione bagni Moncalieri</Link>
                </li>
                <li>
                  <Link to="/Bagni">Ristrutturazione bagni Rivoli</Link>
                </li>
                <li>
                  <Link to="/Bagni">Ristrutturazione bagni Venaria Reale</Link>
                </li>
                <li>
                  <Link to="/Bagni">Ristrutturazione bagni Chieri</Link>
                </li>
                <li>
                  <Link to="/Bagni">Ristrutturazione bagni Orbassano</Link>
                </li>
                <li>
                  <Link to="/Bagni">Ristrutturazione bagni Grugliasco</Link>
                </li>
              </ul>
            </div>
            <div>
              <ul>
                <li >
                  <Link to="/Bagni">Ristrutturazione bagni Pinerolo</Link>
                </li>
                <li>
                  <Link to="/Bagni">Ristrutturazione bagni Volpiano</Link>
                </li>
                <li>
                  <Link to="/Bagni">Ristrutturazione bagni Alpignano</Link>
                </li>
                <li>
                  <Link to="/Bagni">Coprire le piastrelle bagno con piastrelle adesive</Link>
                </li>
                <li>
                  <Link to="/Bagni">Come ristrutturare il bagno a prezzi economici</Link>
                </li>
              </ul>
            </div>
            <div>
              <ul>
                <li>
                  <Link to="/Bagni">Le piastrelle come isolamento acustico per la cucina</Link>
                </li>
                <li>
                  <Link to="/Bagni">Come risparmiare energia con una corretta isolazione termica</Link>
                </li>
                <li>
                  <Link to="/Bagni">Come rinnovare il tuo salotto con un nuovo arredamento</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* Scroll-to-top button */}
        {isVisible && (
          <button onClick={scrollToTop} className="scroll-to-top">
            ↑
          </button>
        )}
      </section>
    </>
  );
}
